module.exports = antd.Rate;